/**
 * Resolução de temas por tenant
 * Adicione novos tenants importando e registrando aqui.
 */

import type { TenantTheme } from './types'
import criminalPlayer from './tenants/criminal-player'
import monkee from './tenants/monkee'

export type { TenantTheme }

/** Mapa de temas registrados */
const TENANT_THEMES: Record<string, TenantTheme> = {
  'criminal-player': criminalPlayer,
  'monkee': monkee
}

/** Tema padrão (fallback) */
const DEFAULT_THEME: TenantTheme = {
  id: 'default',
  appTitle: 'Transcrições',
  showHeaderLogo: true,
  palette: {
    primary: '#1976d2',
    primaryDark: '#1565c0',
  },
  logo: {
    type: 'icon',
    iconGradient: ['#1976d2', '#1565c0'],
  },
  favicon: {
    type: 'emoji',
    value: '🎙️',
  },
}

/**
 * Retorna o tema do tenant pelo ID.
 * Usa o tema padrão se o tenant não for encontrado.
 */
export function getTenantTheme(tenantId?: string | null): TenantTheme {
  if (!tenantId) return DEFAULT_THEME
  return TENANT_THEMES[tenantId] ?? DEFAULT_THEME
}
